export class SequentialQueue {
    constructor() {
        this.queue = [];
        this.retries = 0;
        this.isAborted = false;
        this.pendingNum = 0;
    }

    enqueue(task, options) {
        if(this.isAborted) return;
        const isRunning = this.queue.length;
        if(options) {
            this.configureTask(task, options);
        }
        this.queue.push(task);
        if(!isRunning) {
            this.start();
        }
    }

    configureTask(task, options) {
        if(options.async) {
            task._async = true;
        }
        if(options.abort) {
            task._abort = true;
        }
        if(options.over) {
            task._over = true;
        }
    }

    async start() {
        await this.consume(this.queue[0]);
    }

    abort() {
        this.queue = [];
        this.isAborted = true;
    }

    executeAsyncTask(task) {
        task.call(null).then(async () => {
            this.pendingNum--;
            this.retries = 0;
            await this.consume(this.queue[0]);
        }, () => {
            if(++this.retries >= RETRY_LIMIT) {
                this.pendingNum--;
                return task._abort && this.abort();
            }
            this.consume(task);
        });
        this.pendingNum++;
        this.queue.shift();
    }

    async executeSyncTask(task) {
        try {
            await task.call(null);
            this.retries = 0;
            this.queue.shift();
            if(task._over) {
                this.abort();
            } else {
                await this.consume(this.queue[0]);
            }
        } catch {
            if(++this.retries >= RETRY_LIMIT) {
                return (task._over || task._abort) && this.abort();
            }
            return await this.consume(task);
        }
    }

    async consume(task) {
        if(!task) return;

        if(task._async) {
            this.executeAsyncTask(task);
            return await this.consume(this.queue[0]);
        }
        if(this.pendingNum === 0) {
            await this.executeSyncTask(task);
        }
    }
}

const RETRY_LIMIT = 10;